import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-web-logo-icon',
  templateUrl: './web-logo-icon.component.html',
  styles: []
})
export class WebLogoIconComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
